import React from 'react'
import './Banner.css'
import hero from '../../assets/frontend_assets/hero_img.png'

function Banner() {
  return (
    <div className='banner_container'>
        <div className="banner_left">
            <div className="banner_left_con">
                <p><hr />OUR BESTSELLERS</p>
                <h1>Latest Arrivals</h1>
                <p>SHOP NOW<hr /></p>
            </div>
        </div>
        <div className="banner_right">
            <img src={hero} alt="" />
        </div>
    </div>
  )
}

export default Banner